import script from "./DocsNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsNavBar.vue?vue&type=script&setup=true&lang=js"

import "./DocsNavBar.vue?vue&type=style&index=0&id=8f987706&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f987706"]])

export default __exports__